import { render, staticRenderFns } from "./PropertyDesired.vue?vue&type=template&id=8190fc92"
import script from "./PropertyDesired.vue?vue&type=script&lang=js"
export * from "./PropertyDesired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports